/* eslint-disable no-return-assign */
import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import NoSSR from 'react-no-ssr'
import ResizeAware from 'react-resize-aware'
import get from 'lodash/get'
import MediaQueryMatch from '@pcln/media-query-match'
import classNames from 'classnames'
import { detect } from 'detect-browser'
import Cookies from 'cookies-js'

import queryString from 'query-string'
import { Flex, GenericBanner, Text, Link } from 'pcln-design-system'
import { SearchFormSkeleton } from '@pcln/fly-ui-components'
import { pclnExpt } from '../../../common/fly-experimentation/fly-experimentation.js'
import { AdContainer } from '../../containers/ad-container'
import { translateSearchRequest } from '../../util/translateSearchRequest'
import { ListingsContentContainer } from '../../containers/listings-content-container'
import { FilterChipsMobile } from '../FilterBar/FilterChipsMobile'
import { StickyCSHListener } from '../StickyCSH/StickyCSHListener'
import { StickyCSHWrapper } from '../StickyCSH/StickyCSHWrapper'
import { ResponsiveChangeSearchHeaderWrapper } from '../ResponsiveChangeSearchHeaderWrapper/ResponsiveChangeSearchHeaderWrapper'
import { LeftFilterSkeleton as FilterSkeleton } from '../LeftFilterSkeleton/LeftFilterSkeleton'
import { SETI } from '../../util/transformSETI'
import { fireFlyImpressionFromBrowser } from '../../util/fireFly/fireFlyData'
import { BestPriceGuarantee } from '../BestPriceGuarantee'
import { getIsShelfEligible } from '../../helpers/helpers'
import { SponsoredFilterContainer } from '../SponsoredFilter/SponsoredFilterContainer'
import { SBS_ROUTES, setSbsRouteParam } from '../../util/setSbsRouteParam'
import { isDesktopVP } from '../../util/displayHelpers'
import {
  ListingsHeader,
  ListingsBody,
  Left,
  Middle,
  Right,
  RightAdBox,
  BottomAdBox,
  SopqBanner,
  FullHeightDiv,
  CSHSSRWrapper,
} from './ListingsPage.styles'
import { RoutingHelper } from '../../util/routingHelper'
import { fireFlyConditions } from '../../constants/fireflyCondition'
import { buildListingsFilterProps } from '../ListingsContent/helpers'
import { getIsSbs } from '../../util/sbs/sbs.util.js'

const LazyFilters = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../containers/filters-container')
)
const browser = detect()

class Listings extends React.Component {
  constructor(props) {
    super(props)

    this.seti = SETI
    let translatedRequest = {}

    this.middleStyle = { position: 'relative' }
    let searchType

    if (typeof window !== 'undefined') {
      translatedRequest = translateSearchRequest(
        props.pclnBootstrapData.searchRequest
      )
      this.closeFiltersOnAppLoad()
      const params = queryString.parse(window.location.search)

      // Search type should only ever be a string of digits
      if (params['search-type'] && params['search-type'].match(/^\d+$/)) {
        searchType = params['search-type']
      }
    }

    this.state = {
      ...translatedRequest,
      stickyAdIds: ['div-gpt-ad-tower', 'div-gpt-ad-1485190827857-0'],
      isLOSVariant: get(this.seti, 'AIR_TRIP_LOS_CSH.isVariant', false),
      setiArray: get(props, 'pclnBootstrapData.requestLocals.seti', []),
      searchType,
      calendarPricingMap: props.calendarPricingMap || [],
      hasSopqError: get(props, 'pclnBootstrapData.sopqError', false),
      displayAds: this.props.enableAds,
      showDesktopFilters: false,
      filterKey: Date.now(),
      forceOpen: false,
    }

    this.isDesktop = isDesktopVP()

    this.attributeFilterConditions =
      fireFlyConditions.isFireFly() &&
      this.isDesktop &&
      this.state.tripType === 'OW' &&
      this.props.pclnBootstrapData.hasUSDestinationsOnly

    this.displayAttributeFilter =
      this.seti?.AIR_LISTINGS_ATTRIBUTE_FILTER_CACHED?.isVariant &&
      this.attributeFilterConditions

    this.isRebook = Cookies.get('isRebook')
    // expire cookie
    Cookies.set('isRebook', true, {
      domain: '.priceline.com',
      expires: 'Thu, 01 Jan 1970 00:00:01 GMT',
      path: '/m/fly/search',
    })
  }

  componentDidMount() {
    setSbsRouteParam(SBS_ROUTES[1])
    this.routingHelper = new RoutingHelper()

    if (this.isDesktop) {
      pclnExpt.fireImpression('AIR_LISTINGS_FILTER_SPACING')
      pclnExpt.fireImpression('AIR_LISTINGS_CAPITALIZED_STOP_FILTERS')
    }

    if (!this.isDesktop) {
      pclnExpt.fireImpression('AIR_LISTINGS_CAPITALIZED_STOP_FILTERS_MOBILE')
    }
    //  Fire Firefly Impressions
    fireFlyImpressionFromBrowser({
      pclnBootstrapData: this.props.pclnBootstrapData,
      pclnExpt,
    })

    if (!this.props.pclnBootstrapData?.partner?.partnerCode) {
      pclnExpt.fireImpression('REFRESH_COREPATH_2022')
    }

    //Time filter chip redesign

    if (this.state.tripType === 'OW') {
      pclnExpt.fireImpression('AIR_LISTINGS_FILTER_REDESIGN_TIME')
    }
  }

  loadFilters = e => {
    e.preventDefault()
    this.routingHelper.goToFilters()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const updatedState = {}
    const { filtersAreReady } = nextProps
    let doUpdateState = false

    if (this.props.airlines !== nextProps.airlines) {
      updatedState.airlines = nextProps.airlines.airlineTable
      doUpdateState = true
    }

    if (filtersAreReady && this.props.filtersAreReady !== filtersAreReady) {
      this.setState({
        showDesktopFilters: true,
      })
    }

    if (doUpdateState) {
      this.setState(updatedState)
    }
  }

  /**
   * Redirect to listings route if initial listings haven't loaded and filters route is active.
   */
  closeFiltersOnAppLoad = () => {
    const { pathname, search, hash } = location

    if (
      !this.props.fetchedInitialListings &&
      pathname.indexOf('/filter') > -1
    ) {
      const listingsPath = pathname.replace(/\/filter$/, '/')
      this.props.history.push(`${listingsPath}${search}${hash}`)
    }
  }

  clearFilters = () => {
    this.props.setInitialFilter()

    this.filterKeyTimeout = setTimeout(() => {
      this.setState({ filterKey: Date.now() })
    }, 0)
  }

  forceHeaderOpen = () => {
    this.setState(prevState => ({
      forceOpen: !prevState.forceOpen,
    }))
  }

  delayedStateUpdate = (changed, type) => {
    const {
      listingsFilterCall,
      pclnBootstrapData,
      activeTabId,
      updateAirlineFiltersReq,
      updateStopsFiltersReq,
      updateAirportsFiltersReq,
      airlinesFilter,
      airportsFilter,
      updateExactDateFiltersReq,
    } = this.props
    this.delyedFilterupdate = setTimeout(() => {
      const isSBS = getIsSbs()
      switch (type) {
        case 'STOP':
          {
            updateStopsFiltersReq(
              changed,
              {},
              {
                isSBS,
                activeTabId: activeTabId,
              }
            )
          }
          break
        case 'AIRLINE':
          {
            updateAirlineFiltersReq(changed, {}, airlinesFilter, {
              isSBS,
              activeTabId: activeTabId,
            })
          }
          break
        case 'AIRPORT':
          {
            updateAirportsFiltersReq(
              changed,
              airportsFilter,
              {},
              {
                isSBS,
                activeTabId: activeTabId,
              }
            )
          }
          break
        case 'ALTDATES':
          {
            updateExactDateFiltersReq(changed)
          }
          break
        default:
      }
      listingsFilterCall(pclnBootstrapData)
    }, 0)
  }

  generateFiltersList = () => {
    const {
      airlinesFilter,
      stopsFilter,
      airportsFilter,
      altDatesFilter,
      attributesFilter,
      filterDefaults,
      filterValues,
      updateStopsFiltersUI,
      updateAirlineFiltersUI,
      updateAirportsFiltersUI,
      updateExactDateFiltersUI,
      resetTimeFilters,
      updateTimeFilters,
      updateAttributesFiltersUI,
    } = this.props

    const sliceRefId = this.props.timeFilter?.[0]?.sliceRefId

    const timeFilter = {
      minTakeoffTime: filterValues[`departTimeStart${sliceRefId}`],
      maxTakeoffTime: filterValues[`departTimeEnd${sliceRefId}`],
      minLandingTime: filterValues[`arriveTimeStart${sliceRefId}`],
      maxLandingTime: filterValues[`arriveTimeEnd${sliceRefId}`],
      sliceDurationMin: filterValues[`sliceDurationMin${sliceRefId}`],
      sliceDurationMax: filterValues[`sliceDurationMax${sliceRefId}`],
      sliceRefId,
    }

    return buildListingsFilterProps({
      airlinesFilter,
      stopsFilter,
      airportsFilter,
      altDatesFilter,
      attributesFilter,
      timeFilter,
      filterDefaults,
      updateStopsFiltersUI,
      delayedStateUpdate: this.delayedStateUpdate.bind(this),
      updateAirlineFiltersUI,
      updateAirportsFiltersUI,
      updateExactDateFiltersUI,
      resetTimeFilters,
      updateTimeFilters,
      updateAttributesFiltersUI,
    })
  }

  componentWillUnmount() {
    if (this.filterKeyTimeout) {
      clearTimeout(this.filterKeyTimeout)
    }

    if (this.delayedStateUpdate) {
      clearTimeout(this.delayedStateUpdate)
    }
  }

  renderAd = (adId, isSticky = false, minScreenSize, marginBottom = 0) => {
    return (
      this.state.displayAds && (
        <NoSSR>
          <AdContainer
            adId={adId}
            isSticky={isSticky}
            minScreenSize={minScreenSize}
            marginBottom={marginBottom}
          />
        </NoSSR>
      )
    )
  }

  disableSOPQError = () => this.setState({ hasSopqError: false })

  closeMobileFilters = () => this.props.setCurrentMobileFilter('')

  padRightAds = () => {
    return !this.props.fetchedInitialListings
  }

  render() {
    const {
      showLoadingOverlay,
      listingsIsLoading,
      fetchedInitialListings,
      pclnBootstrapData: {
        features,
        searchRequest,
        hasUSDestinationsOnly,
        partner,
        isReshopExperience,
        offerToken,
      },
      hasExpressDeal,
      hasUpsellOptions,
    } = this.props
    const {
      travelers,
      cabinClass,
      slices,
      showDesktopFilters,
      tripType,
      filterKey,
    } = this.state
    /**
     * Disable Flexible Dates Checkbox for Firefly OW
     * */
    const displayFlexibleDatesCheckbox = !fireFlyConditions.isFireFly()

    const shouldRenderCSH = !listingsIsLoading
    const sopqErrorContent = (
      <SopqBanner
        bg='primary.light'
        onClose={this.disableSOPQError}
        showIcon={'false'}
        textAlign={'left'}
      >
        Oops! There are no Express Deals<sup>&reg;</sup> for your search. Try
        again or check out our great retail fares below!
      </SopqBanner>
    )

    const stickyCSHAnchorId = 'sticky-csh-anchor'
    const stickyCSHWrapperId = 'sticky-csh-wrapper'
    const hiddenClassName = 'sticky-dynamic-hide'

    const opacityMaskCss = classNames('', {
      'opacity-mask': listingsIsLoading,
    })

    // AIR-22118: AIR_SEARCH_BRANDED_SHELF_NGS_OW2
    const isShelfEligible = getIsShelfEligible(
      searchRequest,
      hasUSDestinationsOnly,
      tripType,
      hasExpressDeal,
      cabinClass,
      get(browser, 'name', ''),
      this.isDesktop,
      hasUpsellOptions
    )

    const is3ShelfVariant =
      isShelfEligible &&
      get(
        this.seti,
        'AIR_SEARCH_BRANDED_SHELF_NGS_OW2.variantName',
        'DEFAULT'
      ) === 'THREESHELVES'

    return (
      <FullHeightDiv>
        <StickyCSHWrapper
          stickyCSHAnchorId={stickyCSHAnchorId}
          stickyCSHWrapperId={stickyCSHWrapperId}
          hiddenClassName={hiddenClassName}
          showStickyHeader={!listingsIsLoading}
          isMobileFilterChip={!isDesktopVP()}
        >
          <ListingsHeader showBoxShadow={this.props.fetchedInitialListings}>
            {
              <div>
                {this.state.hasSopqError && sopqErrorContent}
                <CSHSSRWrapper
                  minHeight='112px'
                  desktop
                  showCshAfterListingsLoad
                  className={opacityMaskCss}
                >
                  <MediaQueryMatch minWidth={'xs'}>
                    {shouldRenderCSH && (
                      <React.Fragment>
                        <StickyCSHListener
                          stickyCSHAnchorId={stickyCSHAnchorId}
                          stickyCSHWrapperId={stickyCSHWrapperId}
                          hiddenClassName={hiddenClassName}
                        />
                        <ResponsiveChangeSearchHeaderWrapper
                          forceOpen={this.state.forceOpen}
                          forceHeaderOpen={this.forceHeaderOpen}
                          defaultTripSlices={slices}
                          defaultTripType={tripType}
                          defaultCabinClass={cabinClass}
                          resetSearchFields={pclnExpt.isVariant(
                            'AIR_LISTINGS_REVERT_CSH_FIELDS'
                          )}
                          defaultPassengers={travelers}
                          defaultAirports={searchRequest?.airports}
                          airlines={this.state.airlines}
                          filterOnClick={this.loadFilters}
                          isWhiteLabel={!!partner}
                          urlRoot={'/m/fly/search/'}
                          pclnExpt={pclnExpt}
                          displayFlexibleDatesCheckbox={
                            displayFlexibleDatesCheckbox
                          }
                          isReshopExperience={isReshopExperience}
                          queryParams={{
                            'offer-token': offerToken || undefined,
                          }}
                        />
                      </React.Fragment>
                    )}
                  </MediaQueryMatch>
                  {typeof window === 'undefined' && (
                    <Flex justifyContent={'center'} color='background.light'>
                      <SearchFormSkeleton whiteOnGray />
                    </Flex>
                  )}
                </CSHSSRWrapper>
              </div>
            }
          </ListingsHeader>
        </StickyCSHWrapper>
        {this.isRebook && (
          <GenericBanner
            text={
              <Text.span textColor='primary.base' mr={1}>
                Once you’ve selected your flights from the list, call Customer
                Service at{' '}
                <Link variation='link' href='tel:(206) 971-2182'>
                  (206) 971-2182
                </Link>{' '}
                to re-book. Please have your previous trip number ready when you
                call. You can find this in the “Find My Trip” section of the
                website.
              </Text.span>
            }
            p={3}
            m={'0 auto'}
            color='caution.light'
            style={{
              maxWidth: '1380px',
            }}
          />
        )}

        {/* show mobile filter tabs */}
        <NoSSR>
          {!showLoadingOverlay && (
            <MediaQueryMatch maxWidth={'xl'}>
              <FilterChipsMobile />
            </MediaQueryMatch>
          )}
        </NoSSR>

        <ListingsBody justifyContent={'center'}>
          <Left className={opacityMaskCss}>
            {!isReshopExperience && this.state.displayAds && (
              <SponsoredFilterContainer />
            )}

            {/* Desktop Filters */}
            {fetchedInitialListings && showDesktopFilters && (
              <MediaQueryMatch minWidth={'md'}>
                <Suspense fallback={<FilterSkeleton />}>
                  <LazyFilters
                    key={filterKey}
                    hasExpressDeal={hasExpressDeal}
                    features={features}
                    displayAttributeFilter={this.displayAttributeFilter}
                  />
                </Suspense>
              </MediaQueryMatch>
            )}

            {listingsIsLoading && !fetchedInitialListings && <FilterSkeleton />}

            {/* Best price guarantee left rail */}
            {fetchedInitialListings &&
              features?.whiteLabel?.bestPriceGuaranteeEnabled &&
              !this.props.pclnBootstrapData?.isReshopExperience && (
                <MediaQueryMatch minWidth={'md'}>
                  <BestPriceGuarantee />
                </MediaQueryMatch>
              )}

            {/* Left tower ads */}
            {this.renderAd('div-gpt-ad-tower', true, 'desktop')}
          </Left>

          {/* eslint-disable react/no-string-refs */}
          <Middle
            displayAds={this.props.enableAds}
            is3ShelfVariant={is3ShelfVariant}
          >
            <ResizeAware
              onlyEvent
              style={this.middleStyle}
              ref={'middleColumn'}
            >
              <ListingsContentContainer
                clearFilters={this.clearFilters}
                airlinesFilter={this.props.airlinesFilter}
                altDatesFilter={this.props.altDatesFilter}
                stopsFilter={this.props.stopsFilter}
                airportsFilter={this.props.airportsFilter}
                timeFilter={this.props.timeFilter}
                filtersLists={this.generateFiltersList()}
                forceHeaderOpen={this.forceHeaderOpen}
                attributeFilterConditions={this.attributeFilterConditions}
              />
            </ResizeAware>
          </Middle>
          {/* eslint-enable react/no-string-refs */}

          {this.props.enableAds && (
            <Right
              className={opacityMaskCss}
              pt={this.padRightAds() ? '174px' : 0}
              is3ShelfVariant={is3ShelfVariant}
            >
              <MediaQueryMatch minWidth={'lg'}>
                <RightAdBox>
                  {this.renderAd('div-gpt-ad-box', false, 'desktoplg', 8)}
                </RightAdBox>

                <RightAdBox>
                  {this.renderAd('div-gpt-ad-box-2', false, 'tablethd', 51)}
                </RightAdBox>

                {this.renderAd('div-gpt-ad-1485190827857-0', true, 'tablethd')}
              </MediaQueryMatch>
            </Right>
          )}
        </ListingsBody>

        <Flex justifyContent={'center'} className={opacityMaskCss}>
          <MediaQueryMatch minWidth={'md'}>
            {this.props.enableAds && (
              <BottomAdBox mb={4}>
                {this.renderAd('div-gpt-ad-1470951919306-0', false, 'desktop')}
              </BottomAdBox>
            )}
          </MediaQueryMatch>
        </Flex>
      </FullHeightDiv>
    )
  }
}

Listings.contextTypes = {
  pclnBootstrapData: PropTypes.object,
}

Listings.defaultProps = {
  listingsIsLoading: false,
  showLoadingOverlay: false,
}

Listings.propTypes = {
  pclnBootstrapData: PropTypes.object,
  SETI: PropTypes.array,
  currentMobileFilter: PropTypes.string,
  setCurrentMobileFilter: PropTypes.func,
  fetchedInitialListings: PropTypes.bool,
  enableAds: PropTypes.bool,
  listingsIsLoading: PropTypes.bool,
  showLoadingOverlay: PropTypes.bool,
  airlines: PropTypes.object,
  setSessionExpired: PropTypes.func,
  calendarPricingMap: PropTypes.array,
  expiredSessionTimestamp: PropTypes.number,
  history: PropTypes.object,
  filtersAreReady: PropTypes.bool,
  voidWindowInfo: PropTypes.string,
  hasExpressDeal: PropTypes.bool,
  isAirCanada: PropTypes.bool,
  hasUpsellOptions: PropTypes.bool,
  altDeals: PropTypes.array,
  cheapestPrice: PropTypes.number,

  // redux state
  airlinesFilter: PropTypes.array,
  altDatesFilter: PropTypes.array,
  stopsFilter: PropTypes.object,
  airportsFilter: PropTypes.array,
  timeFilter: PropTypes.array,
  attributesFilter: PropTypes.array,
  setInitialFilter: PropTypes.func,
  clearAllFilters: PropTypes.func,
  activeTabId: PropTypes.number,
  filterDefaults: PropTypes.object,
  filterValues: PropTypes.object,

  // indivisual filter update funcs
  updateStopsFiltersUI: PropTypes.func,
  updateStopsFiltersReq: PropTypes.func,
  listingsFilterCall: PropTypes.func,
  updateAirlineFiltersReq: PropTypes.func,
  updateAirlineFiltersUI: PropTypes.func,
  updateAttributesFiltersUI: PropTypes.func,
  updateAirportsFiltersReq: PropTypes.func,
  updateAirportsFiltersUI: PropTypes.func,
  updateExactDateFiltersUI: PropTypes.func,
  updateExactDateFiltersReq: PropTypes.func,
  resetTimeFilters: PropTypes.func,
  updateTimeFilters: PropTypes.func,
}

export { Listings }
